import React, {useEffect, useRef, useState} from 'react';
import RightTopAds from "./ads/RightTopAds";
import RightMidAds from "./ads/RightMidAds";
import BottomRightAds from "./ads/BottomRightAds";

const RightSide = () => {
    const bottomAdsStartRef = useRef(null);
    const bottomAdsStartOffsetRef = useRef(0);
    const animationFrameRef = useRef(null);
    const [bottomAdsPaddingTop, setBottomAdsPaddingTop] = useState(0);

    useEffect(() => {
        const updateBottomAdsPosition = () => {
            const nextPaddingTop = Math.max(
                0,
                window.pageYOffset - bottomAdsStartOffsetRef.current
            );

            setBottomAdsPaddingTop(nextPaddingTop);
            animationFrameRef.current = null;
        };

        const measureBottomAdsStart = () => {
            const bottomAdsStart = bottomAdsStartRef.current;

            if (!bottomAdsStart) {
                return;
            }

            bottomAdsStartOffsetRef.current =
                window.pageYOffset + bottomAdsStart.getBoundingClientRect().top;
            updateBottomAdsPosition();
        };

        const handleScroll = () => {
            if (animationFrameRef.current) {
                return;
            }

            animationFrameRef.current = window.requestAnimationFrame(
                updateBottomAdsPosition
            );
        };

        measureBottomAdsStart();

        window.addEventListener("scroll", handleScroll, {passive: true});
        window.addEventListener("resize", measureBottomAdsStart);
        window.addEventListener("load", measureBottomAdsStart);

        return () => {
            if (animationFrameRef.current) {
                window.cancelAnimationFrame(animationFrameRef.current);
            }

            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", measureBottomAdsStart);
            window.removeEventListener("load", measureBottomAdsStart);
        };
    }, []);

    return (
        <React.Fragment>
            <td className="right">
                <div id="dnw_right">
                    <RightTopAds/>
                    <div>
                        <div>
                            <div className="modulesLR moduleBrown">
                                <div className="body-l">
                                    <div className="body-r">
                                        <ul className="list_news">
                                            <li>
                                                <a href="/">Thay
                                                    đổi giờ mở thưởng Xổ
                                                    số Miền Bắc</a></li>
                                            <li>
                                                <a href="/">ĐỔI
                                                    SỐ TRÚNG ĐẶC BIỆT Ở
                                                    ĐÂU &amp; THỦ TỤC NHƯ
                                                    THẾ NÀO ?... MINH
                                                    NGỌC TP HCM</a></li>
                                            <li>
                                                <a href="/">Mức
                                                    chi hoa hồng đại lý
                                                    xổ số</a></li>
                                            <li>
                                                <a href="/">Thuế
                                                    thu nhập trúng xổ số
                                                    &amp; cơ cấu giải thưởng
                                                    từ 01/01/2017</a>
                                            </li>
                                            <li>
                                                <a href="/">Nghị
                                                    định 78/2012/NĐ-CP
                                                    về kinh doanh xổ
                                                    số</a></li>
                                            <li>
                                                <a href="/">KHUYẾN
                                                    CÁO KHI ĐỔI SỐ
                                                    TRÚNG</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="clear"/>
                        </div>
                    </div>
                    <RightMidAds/>
                    <div ref={bottomAdsStartRef}/>
                    <div
                        style={{
                            paddingTop: bottomAdsPaddingTop,
                            transition: "padding-top 500ms ease-out"
                        }}>
                        <BottomRightAds/>
                    </div>
                </div>
            </td>
        </React.Fragment>
    );
}

export default RightSide;
